import QuestionnaireForm from 'app/features/questionnaires/components/QuestionnaireForm';
import { useSelector } from 'react-redux';
import { useValidateQuestionnaireForm } from '../../useValidateQuestionnaire';
import { fields, validationSchema } from './fields';
import { selectSoleProprietorshipform1099MiscAnd1099Nec } from './slice';

export interface ISoleProprietorshipform1099MiscAnd1099NecProps {}

const PATH = 'soleProprietorship.soleProprietorshipForm1099MISCand1099NEC';
const SELECTOR = selectSoleProprietorshipform1099MiscAnd1099Nec;

export function useValidateSoleProprietorship() {
  const { values } = useSelector(SELECTOR);

  return useValidateQuestionnaireForm(PATH, values, validationSchema);
}

export default function SoleProprietorshipform1099MiscAnd1099Nec(
  props: ISoleProprietorshipform1099MiscAnd1099NecProps,
) {
  const initialState = useSelector(SELECTOR);

  return (
    <QuestionnaireForm
      defautlValues={initialState.values}
      fields={fields}
      validationSchema={validationSchema}
      className="md-max:grid md-max:grid-cols-4 md-max:gap-y-4"
      fieldClassName="md-max:col-span-4"
    />
  );
}
